/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MnLnbData model module.
 * @module model/MnLnbData
 * @version 1.0
 */
class MnLnbData {
    /**
     * Constructs a new <code>MnLnbData</code>.
     * @alias module:model/MnLnbData
     */
    constructor() { 
        
        MnLnbData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MnLnbData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MnLnbData} obj Optional instance to populate.
     * @return {module:model/MnLnbData} The populated <code>MnLnbData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MnLnbData();

            if (data.hasOwnProperty('gnbNo')) {
                obj['gnbNo'] = ApiClient.convertToType(data['gnbNo'], 'Number');
            }
            if (data.hasOwnProperty('lnbNo')) {
                obj['lnbNo'] = ApiClient.convertToType(data['lnbNo'], 'Number');
            }
            if (data.hasOwnProperty('lnbName')) {
                obj['lnbName'] = ApiClient.convertToType(data['lnbName'], 'String');
            }
            if (data.hasOwnProperty('pageUrl')) {
                obj['pageUrl'] = ApiClient.convertToType(data['pageUrl'], 'String');
            }
            if (data.hasOwnProperty('sort')) {
                obj['sort'] = ApiClient.convertToType(data['sort'], 'Number');
            }
            if (data.hasOwnProperty('enabled')) {
                obj['enabled'] = ApiClient.convertToType(data['enabled'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MnLnbData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MnLnbData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['lnbName'] && !(typeof data['lnbName'] === 'string' || data['lnbName'] instanceof String)) {
            throw new Error("Expected the field `lnbName` to be a primitive type in the JSON string but got " + data['lnbName']);
        }
        // ensure the json data is a string
        if (data['pageUrl'] && !(typeof data['pageUrl'] === 'string' || data['pageUrl'] instanceof String)) {
            throw new Error("Expected the field `pageUrl` to be a primitive type in the JSON string but got " + data['pageUrl']);
        }

        return true;
    }


}



/**
 * @member {Number} gnbNo
 */
MnLnbData.prototype['gnbNo'] = undefined;

/**
 * @member {Number} lnbNo
 */
MnLnbData.prototype['lnbNo'] = undefined;

/**
 * @member {String} lnbName
 */
MnLnbData.prototype['lnbName'] = undefined;

/**
 * @member {String} pageUrl
 */
MnLnbData.prototype['pageUrl'] = undefined;

/**
 * @member {Number} sort
 */
MnLnbData.prototype['sort'] = undefined;

/**
 * @member {Boolean} enabled
 */
MnLnbData.prototype['enabled'] = undefined;






export default MnLnbData;

